import { CssBaseline } from '@mui/material'
import { StyledEngineProvider, ThemeProvider as MUIThemeProvider } from '@mui/material/styles'
import { PropsWithChildren, useMemo } from 'react'

import defaultTheme from '#/styles/Themes'

import '#/index.css'

export function ThemeProvider({ children }: PropsWithChildren) {
  const theme = useMemo(() => defaultTheme(), [])

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  )
}
